<template>
  <div>
    <div class="user_info" v-show="selectedZoneLocal">
      {{selectedRole && selectedRole.name ? selectedRole.name : ""}}：{{selectedZoneLocal.zone_name}}
      <span
        @click="showZoneRole"
        class="switch"
      >切换></span>
    </div>
    <div class="user_info" v-show="!selectedZoneLocal">
      <span
        @click="showZoneRole"
        class="switch"
      >选择大区角色></span>
    </div>
    <div class="alert_container" v-if="isShown">
      <div class="alert_bg"></div>
      <div class="alert_outbox alert_select">
        <div class="alert_content border_box">
          <div class="corner"></div>
          <div class="corner"></div>
          <div class="corner"></div>
          <div class="corner"></div>

          <div class="close_btn" @click="closeZoneRole"></div>
          <div class="title"></div>
          <div class="select_box">
            <div class="select_list">
              <div class="label">平台</div>
              <select
                class="alert_select_option alert_select_platform"
                name="platform"
              >
                <option value="1">{{sysName}}</option>
              </select>
            </div>
            <div class="select_list">
              <div class="label">大区</div>
              <select class="alert_select_option alert_select_region" name="zone" @change="changeZone(selectedZoneLocal)" v-model="selectedZoneLocal">
                <option
                  :key="index"
                  :value="zone"
                  v-for="(zone,index) in zoneInfo"
                >{{zone.zone_name}}</option>
              </select>
            </div>
            <div class="select_list">
              <div class="label">角色</div>
              <select class="alert_select_option alert_select_role" name="role">
                <option value="1" v-if="selectedRole">{{selectedRole.name || ""}}</option>
              </select>
            </div>
          </div>

          <div class="btn_box">
            <div class="btn one_btn" @click="closeZoneRole">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import localStorage from "../../common/utils/localStorage"
import * as url from "../../common/utils/url"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "ZoneRole",
  data() {
    return {
      isShown: false,
      zoneInfo: "",
      selectedZoneLocal: "",
      initPromise: null
    }
  },
  props: ["onSelectRole"],
  computed: {
    ...mapGetters(["offerId", "loginState", "userAgent", "selectedZone", "selectedRole"]),
    sysName() {
      let account = "QQ"
      let plat = this.userAgent.iOS ? "iOS" : "安卓"
      if (this.loginState.session_id == "hy_gameid" && this.loginState.session_type == "wc_actoken") {
        account = "微信"
      }
      return `${plat}-${account}`
    }
  },
  created() {
    this.initZoneAndRole()
  },
  methods: {
    ...mapActions([
      "setToastMsg",
      "getMobileZoneInfo",
      "getUserRecommendZone",
      "getMobileRoleInfo",
      "setSelectedRole",
      "setSelectedZone",
      "setPartitionInfo",
      "reportUserAction",
      "clearSelectZoneRole"
    ]),

    initZoneAndRole() {
      if (this.initPromise) {
        return this.initPromise
      } else {
        this.initPromise = Promise.resolve().then(() => {
          // 初始化时清空
          this.selectedZoneLocal = ""

          // store里有，则优先使用store里的
          // 非MSDK，优先使用缓存(localstorage)，其次使用推荐
          // MSDK，使用partition参数
          if (this.selectedZone) {
            this.selectedZoneLocal = this.selectedZone
            this.getZoneInfo()
            return
          } else if (!this.userAgent.msdk) {
            let defaultSelectedZone = localStorage.get(
              `wzry_activity_${this.offerId}_${this.loginState.openid}_${this.userAgent.weixin ? "wx" : "qq"}`,
              true
            )
            if (!defaultSelectedZone) {
              return Promise.all([this.getZoneInfo(), this.getUserRecommendZone()]).then(results => {
                if (results[1] && results[1].recomm_info && results[1].recomm_info.part) {
                  let recommendZone = this.zoneInfo.filter(zone => {
                    return zone.zone_id == results[1].recomm_info.part
                  })[0]
                  if (recommendZone) {
                    return this.changeZone(recommendZone)
                  }
                }
              })
            } else {
              this.getZoneInfo()
              return this.changeZone(defaultSelectedZone)
            }
          } else {
            // 游戏内，以参数上的partition为准
            return this.getZoneInfo().then(zones => {
              let zoneid = url.getParam("partition")
              let defaultSelectedZone = zones.zone_list.filter(zone => {
                return zone.zone_id == zoneid
              })[0]
              return this.changeZone(defaultSelectedZone)
            })
          }
        })
        return this.initPromise
      }
    },
    getZoneInfo() {
      if (this.zoneInfo) return this.zoneInfo
      return this.getMobileZoneInfo().then(res => {
        this.zoneInfo = res.zone_list
        return res
      })
    },
    handleRoleInfo(res) {
      this.setPartitionInfo(res.partition_info)

      let roles = res.role_info,
        rolesArr = []
      roles.forEach(item => {
        if (item) {
          rolesArr.push({ name: decodeURIComponent(item.role_name), id: item.role_id })
        }
      })
      if (rolesArr.length == 0) {
        this.setToastMsg("你在此区无游戏角色")
      } else {
        this.setSelectedRole(rolesArr[0])
      }
    },
    changeZone(zone) {
      // 先清除选中
      this.clearSelectZoneRole()

      return this.getMobileRoleInfo({ zoneid: zone.zone_id })
        .then(res => {
          this.setSelectedZone(zone)
          this.handleRoleInfo(res)
          this.selectedZoneLocal = zone
        })
        .catch(res => {
          // 先清除选中
          this.clearSelectZoneRole()
          this.selectedZoneLocal = ""

          if (res.ret == 1220) {
            this.setToastMsg("你在此区无游戏角色")
          } else {
            this.setToastMsg(res.msg || "查询角色系统繁忙，请稍候再试")
          }
        })
    },
    showZoneRole() {
      this.selectedZoneLocal = this.selectedZone

      this.isShown = true

      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.ZONE_ROLE
      })
    },
    closeZoneRole() {
      if (this.selectedZone && this.selectedRole) {
        this.isShown = false
        this.onSelectRole && this.onSelectRole()
      } else {
        this.setToastMsg("请选择大区角色")
      }
    }
  }
}
</script>

<style scoped>
.banner .title {
  position: initial;
}
</style>
